import { render, staticRenderFns } from "./aboutSuppliers.vue?vue&type=template&id=2acbe316&scoped=true&"
import script from "./aboutSuppliers.vue?vue&type=script&lang=js&"
export * from "./aboutSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./aboutSuppliers.vue?vue&type=style&index=0&id=2acbe316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbe316",
  null
  
)

export default component.exports